<!--
 * @Description: 
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane name="1" label="自然人完税证明">
      <table-render
        v-if="activeName === '1'"
        :key="showUploadDutypaidProof"
        ref="tableRender"
        :config="config"
        style="padding:20px 10px;margin-top:0;height: initial;"
      />
    </el-tab-pane>
    <el-tab-pane name="2" label="个体自然人完税证明">
      <Personality
        :specialType="specialType"
        v-if="activeName === '2'"
      ></Personality>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { taxPayment } from '@/api/ajax';
import tableRender from '@/components/tableRender';
import { main } from './config';
import Personality from './components/Personality.vue';
export default {
  data() {
    return {
      activeName: '1',
      showUploadDutypaidProof: false,
      specialType: 0 //是否为特殊企业 0-否 1-是
    };
  },
  components: { tableRender, Personality },
  watch: {},
  computed: {
    config() {
      return main(this.showUploadDutypaidProof);
    }
  },
  methods: {},
  created() {
    taxPayment.enterpriseType().then(({ data: { data } }) => {
      this.showUploadDutypaidProof = data === '2:运营基地';
    });
    taxPayment.getEntType().then(res => {
      this.specialType = res.pdata;
    });
  }
};
</script>

<style scoped lang="scss"></style>
